export default __webpack_public_path__ + "10411461c78777fed4f257b5bf3cd5eb.png";